"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAttributeValueTotalMap = exports.buildSpecialValueRecords = void 0;
const attributes_1 = require("../../constants/attributes");
const buildSpecialValueRecords = (counts, attribute, displayedNodeIds) => counts.flatMap(({ dimensions: { productTreeNode }, notApplicable, unknown, }) => {
    if (!productTreeNode || !displayedNodeIds.has(productTreeNode.id))
        return [];
    const baseRecord = {
        nodeId: productTreeNode.id,
        title: productTreeNode.title,
        attribute,
        parentTitle: '',
        parentId: '',
    };
    return [
        Object.assign(Object.assign({}, baseRecord), { value: attributes_1.SpecialAttributeValue.NotApplicable, applied: notApplicable, isMapped: true }),
        Object.assign(Object.assign({}, baseRecord), { value: attributes_1.SpecialAttributeValue.Unknown, applied: unknown, isMapped: true }),
    ];
});
exports.buildSpecialValueRecords = buildSpecialValueRecords;
const buildAttributeValueTotalMap = (totals) => {
    const totalMap = new Map();
    totals.forEach(({ applied, dimensions: { attribute, value }, notApplicable, unknown, }) => {
        const key = value !== null && value !== void 0 ? value : attribute;
        if (key)
            totalMap.set(key, applied);
        if (!attribute || value)
            return;
        totalMap.set(attributes_1.SpecialAttributeValue.NotApplicable, notApplicable);
        totalMap.set(attributes_1.SpecialAttributeValue.Unknown, unknown);
    });
    return totalMap;
};
exports.buildAttributeValueTotalMap = buildAttributeValueTotalMap;
